import type {NodeParameters} from "#graph/nodes/base/types"
import type {VersionChain} from "#graph/versioning/types"

export const convertVersion = (parameters: NodeParameters, fromVersion: number, versionChain: VersionChain, nodeClass: string) => {
    const currentVersion = versionChain.length
    if (currentVersion === fromVersion) return parameters
    if (fromVersion > currentVersion || fromVersion < 0) {
        throw new Error(`Version ${fromVersion} not supported for ${nodeClass}`)
    }
    const [f0, ...fs] = versionChain.slice(fromVersion)
    return fs.reduce((a, f) => f.toNextVersion(a), f0.toNextVersion(parameters))
}
